(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const headings = section.querySelectorAll(".media-banner__heading");

    headings.forEach((text) => {
      ScrollTrigger.create({
        trigger: text,
        start: "50% 95%",
        end: "bottom top",
        onEnter: () => text.classList.add("animated"),
      });
    });
  };

  initAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
  });
})();
